export enum SocialMedia {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Linkedin = 'Linkedin',
  Tiktok = 'Tiktok',
  Twitter = 'Twitter',
}
